<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = withDefaults(
  defineProps<{
    type?: number
    bidType?: 'manual' | 'unified' | string | number
    paymentType?: 'cpm' | 'cpc' | string
  }>(),
  {
    type: 0,
  },
)

const { t } = useI18n()

const typeConfig = computed(() => {
  // Handle bid_type based campaigns (new API structure)
  if (props.bidType) {
    const isManual = props.bidType === 'manual' || props.bidType === 1
    const bidLabel = isManual ? t('manual_bid') : t('unified_bid')
    const paymentLabel = props.paymentType === 'cpc' ? 'CPC' : 'CPM'
    return {
      label: `${bidLabel} (${paymentLabel})`,
      class: 'bg-[#E8F5E9] text-[#2E7D32]',
    }
  }

  // Legacy campaign types (deprecated) - for backwards compatibility
  switch (props.type) {
    case 4:
      return {
        label: t('campaign_type_catalog'),
        class: 'bg-[#FFF3E0] text-[#E65100]',
      }
    case 5:
      return {
        label: t('campaign_type_product_card'),
        class: 'bg-[#FFF3E0] text-[#E65100]',
      }
    case 6:
      return {
        label: t('campaign_type_search'),
        class: 'bg-[#FFF3E0] text-[#E65100]',
      }
    case 7:
      return {
        label: t('campaign_type_recommendations'),
        class: 'bg-[#FFF3E0] text-[#E65100]',
      }
    case 8:
      return {
        label: t('campaign_type_single_rate'),
        class: 'bg-[#D9ECFF] text-brand-primary',
      }
    case 9:
      return {
        label: t('campaign_type_auto'),
        class: 'bg-[#D9ECFF] text-brand-primary',
      }
    default:
      return {
        label: t('campaign_type_auto'),
        class: 'bg-[#D9ECFF] text-brand-primary',
      }
  }
})
</script>

<template>
  <div
    class="px-2 py-0.5 rounded-[32px] text-sm font-normal"
    :class="[typeConfig.class]"
  >
    {{ typeConfig.label }}
  </div>
</template>
